module.exports = __webpack_public_path__ + "static/media/dohlogo.248b5396.png";